// extracted by mini-css-extract-plugin
export var circularProgress = "CircularProgress-module--circularProgress--4a7a2";
export var rotate = "CircularProgress-module--rotate--5cae3";